import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-cyan-50">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
            <div className="text-center mb-12">
              <div className="inline-block bg-gradient-to-r from-pink-500/20 to-cyan-500/20 rounded-full px-6 py-2 mb-6">
                <span className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-cyan-400">PRIVACY POLICY</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                個人情報保護方針
              </h1>
              <div className="h-1 w-24 bg-gradient-to-r from-pink-400 to-cyan-400 mx-auto rounded-full"></div>
            </div>

            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-8">
                STELLAR LIVE（以下「当社」といいます）は、個人情報の重要性を認識し、その適切な保護を社会的責務と考え、以下のとおり個人情報保護方針を定め、全従業員に周知徹底するとともに、個人情報の保護に努めてまいります。
              </p>

              <section className="mb-10">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl flex-shrink-0">
                    <span className="text-white font-bold text-lg">1</span>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">個人情報の管理</h2>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed ml-16">
                  当社は、所属ライバー・VTuber・応募者・取引先・お客さまの個人情報を正確かつ最新の状態に保ち、不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持、管理体制の整備、従業員教育の徹底等、必要かつ適切な安全対策を講じ、厳重に管理いたします。
                </p>
              </section>

              <section className="mb-10">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl flex-shrink-0">
                    <span className="text-white font-bold text-lg">2</span>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">個人情報の利用目的</h2>
                  </div>
                </div>
                <div className="ml-16">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    お預かりした個人情報は、以下の目的の範囲内で利用いたします。
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">オーディション応募者への連絡および選考</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">所属契約・業務管理</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">お問い合わせへの対応</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">サービスのご案内・資料送付</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">イベント・キャンペーン等の運営</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">その他、上記利用目的に付随する業務</span>
                    </li>
                  </ul>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl flex-shrink-0">
                    <span className="text-white font-bold text-lg">3</span>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">個人情報の第三者への開示・提供</h2>
                  </div>
                </div>
                <div className="ml-16">
                  <p className="text-gray-700 leading-relaxed mb-4">
                    当社は、個人情報を適切に管理し、次の場合を除き第三者に開示・提供いたしません。
                  </p>
                  <ul className="space-y-3 mb-4">
                    <li className="flex items-start space-x-3">
                      <i className="ri-arrow-right-circle-fill text-cyan-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">ご本人の同意がある場合</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-arrow-right-circle-fill text-cyan-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">業務委託先（配信プラットフォーム関連業務、制作業務、決済業務等）に必要な範囲で開示する場合</span>
                    </li>
                    <li className="flex items-start space-x-3">
                      <i className="ri-arrow-right-circle-fill text-cyan-500 text-xl flex-shrink-0 mt-1"></i>
                      <span className="text-gray-700">法令に基づき開示が必要な場合</span>
                    </li>
                  </ul>
                  <p className="text-gray-700 leading-relaxed">
                    なお、決済が発生する場合には、本人確認・請求先確認・与信調査のため、決済会社へ必要な情報を提供することがあります。
                  </p>
                </div>
              </section>

              <section className="mb-10">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl flex-shrink-0">
                    <span className="text-white font-bold text-lg">4</span>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">個人情報の安全対策</h2>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed ml-16">
                  当社は、個人情報の漏洩・滅失・毀損を防止するため、合理的な安全対策を講じ、継続的な改善に努めます。
                </p>
              </section>

              <section className="mb-10">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl flex-shrink-0">
                    <span className="text-white font-bold text-lg">5</span>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">個人情報の照会・訂正・削除等</h2>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed ml-16">
                  ご本人から自己の個人情報について、照会・訂正・削除・利用停止等のご請求があった場合には、ご本人確認を行ったうえで、法令に従い速やかに対応いたします。
                </p>
              </section>

              <section className="mb-10">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-cyan-500 rounded-xl flex-shrink-0">
                    <span className="text-white font-bold text-lg">6</span>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">法令遵守および見直し</h2>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed ml-16">
                  当社は、個人情報保護法その他関連法令およびガイドラインを遵守し、本方針の内容を適宜見直し、継続的な改善に努めます。
                </p>
              </section>

              <div className="mt-12 pt-8 border-t border-gray-200">
                <p className="text-sm text-gray-600 text-center">
                  制定日：2025年1月18日<br />
                  STELLAR LIVE
                </p>
              </div>
            </div>

            <div className="mt-12 text-center">
              <a
                href="/"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-pink-500 to-cyan-500 text-white text-sm font-bold rounded-full hover:opacity-90 transition-opacity whitespace-nowrap cursor-pointer"
              >
                <i className="ri-home-4-fill text-lg"></i>
                <span>トップページへ戻る</span>
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
